import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { scheduleProductPageWarmup } from "./productPageLoader";

export default function ProductPageWarmup() {
  const ready = useSelector(state => Boolean(state.store?.store?.categories?.length));
  const { pathname } = useLocation();
  const browsing = pathname === "/" || /^\/(category|search)(\/|$)/.test(pathname);
  useEffect(() => {
    if (ready && browsing) return scheduleProductPageWarmup();
  }, [ready, browsing]);
  return null;
}
